/* eslint-disable no-alert */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withTranslation, i18n } from 'language/i18n';
import Layout from 'components/partials/Layout';
import { getSource } from 'models/source';
import SalesSteps from './components/SalesSteps';
import MachineAddressInformation from './components/MachineAddressInformation';
import MachineInformation from './components/MachineInformation';
import PersonalInformation from './components/PersonalInformation';
import CodeEnterence from './components/CodeEnterence';
import Success from './components/Success';

const MachineSales = ({ t }) => {
  const [currentStep, setCurrentStep] = useState('MachineAddressInformation');
  const [sources, setSources] = useState({});
  const [machineData, setMachineData] = useState({
    country: '',
    region: '',
    district: '',
    postalCode: '',
    brand: '',
    machineType: '',
    model: '',
    serialNumber: '',
    condition: '',
    workingHours: '',
    machineYear: '',
    customerName: '',
    customerSurname: '',
    customerCountry: '',
    customerIdentificationNumber: '',
    customerMail: '',
    customerPhone: '',
    customerCompanyName: '',
    customerTaxOffice: '',
    customerTaxNumber: '',
    customerLearnedFrom: '',
    customerMachineParkSize: '',
    customerTitle: '',
    agreementKvkk: false,
    agreementMessaging: false,
    agreementDistanceSelling: false,
  });

  const updateMachineData = ({ name, value }) => {
    if (name === 'region') {
      const districtByRegion = _.chain(sources).get('districts').filter((district) => district.region === value).sortBy('name')
        .value();
      setSources({
        ...sources,
        districtByRegion,
      });
    }
    if (name === 'country') {
      const regionByCountry = _.chain(sources).get('regions').filter((region) => region.country === value).sortBy('name')
        .value();
      setSources({
        ...sources,
        regionByCountry,
      });
    }
    setMachineData({
      ...machineData,
      [name]: value,
    });
  };

  useEffect(() => {
    getSources();
  }, []);

  useEffect(() => {
    const message = t('pageLeaveText');

    const beforeunload = (e) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', beforeunload);

    return () => {
      window.removeEventListener('beforeunload', beforeunload);
    };
  }, []);

  const getSources = async () => {
    try {
      const { source: countries } = await getSource('country');
      const { source: regions } = await getSource('region');
      const { source: sectors } = await getSource('sector');
      const { source: businessTypes } = await getSource('businessType');
      const { source: taxOffices } = await getSource('taxOffice');
      const { source: learnedFroms } = await getSource('learnedFrom');
      const { source: brands } = await getSource('brand');
      const { source: categories } = await getSource('category');
      const { source: districts } = await getSource('district');

      setSources({
        countries,
        regions,
        sectors,
        taxOffices,
        learnedFroms,
        businessTypes,
        brands,
        categories: _.sortBy(categories, [(category) => { return category.name[i18n.language]; }]),
        districts,
      });
    } catch (error) {
      console.log('getSourcesErr', error);
    }
  };

  const componentParams = {
    sources,
    updateMachineData,
    machineData,
    currentStep,
    setCurrentStep,
    setMachineData,
    t,
  };

  const steps = {
    MachineAddressInformation: {
      component: <MachineAddressInformation {...componentParams} />,
      index: 0,
    },
    MachineInformation: {
      component: <MachineInformation {...componentParams} />,
      index: 1,
    },
    PersonalInformation: {
      component: <PersonalInformation {...componentParams} />,
      index: 2,
    },
    CodeEnterence: {
      component: <CodeEnterence {...componentParams} />,
      index: 2,
    },
  };

  return (
    <>
      {
        currentStep === 'Success'
          ? <Success {...componentParams} />
          : (
            <main className="has-header">
              <div className="container">
                <div className="row">
                  <SalesSteps currentStep={steps[currentStep].index} setCurrentStep={setCurrentStep} />
                  {steps[currentStep].component}
                </div>
              </div>
            </main>
          )
      }
    </>
  );
};

MachineSales.propTypes = {
  t: PropTypes.func,
  step: PropTypes.string,
};

export const getServerSideProps = async () => {
  return {
    props: {
      shortHeader: true,
      shortFooter: true,
      headTitle: 'Makina Satış',
    },
  };
};

MachineSales.Layout = Layout;

export default withTranslation('common')(MachineSales);
